import { useTLang } from 'intl/intl';

import type { ShutdownTimeOption } from 'features/menu-page/domain';

export function useMenuBodySnackBarLang() {
  return {
    turnOnItem: {
      success: {
        title: useTLang({ id: 'menuPage.snackBar.turnOnItem.success.title' }),
        msg: useTLang({ id: 'menuPage.snackBar.turnOnItem.success.msg' }),
      },
      error: {
        title: useTLang({ id: 'menuPage.snackBar.turnOnItem.error.title' }),
        msg: useTLang({ id: 'menuPage.snackBar.turnOnItem.error.msg' }),
      },
    },
    turnOffItem: {
      success: {
        title: {
          product: useTLang({
            id: 'menuPage.snackBar.turnOffItem.success.title.product',
          }),
          custom: useTLang({
            id: 'menuPage.snackBar.turnOffItem.success.title.custom',
          }),
        },
        msg: {
          DAILY: useTLang({
            id: 'menuPage.snackBar.turnOffItem.success.msg.DAILY',
          }),
          CUSTOM: useTLang({
            id: 'menuPage.snackBar.turnOffItem.success.msg.CUSTOM',
          }),
          PERMANENT: useTLang({
            id: 'menuPage.snackBar.turnOffItem.success.msg.PERMANENT',
          }),
        } as Record<ShutdownTimeOption, string>,
      },
      error: {
        title: useTLang({ id: 'menuPage.snackBar.turnOffItem.error.title' }),
        msg: useTLang({ id: 'menuPage.snackBar.turnOffItem.error.msg' }),
      },
    },
  };
}
